import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { GlobalAddAction } from '@app/global-add/global-add.model';
import { IconComponent } from '@degreed/apollo';
import { ContentUtilsService, Entity } from '@degreed/lxp/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-global-add-buttons',
  templateUrl: 'global-add-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class GlobalAddButtonsComponent {
  private readonly contentUtils = inject(ContentUtilsService);
  private readonly translateService = inject(TranslateService);

  // actions comes in as partial, transformed to a full GlobalAddAction
  public actions = input.required<Partial<GlobalAddAction & Entity>[]>();
  public type = input.required<string>();

  public processedActions = computed(() =>
    this.actions().map((action) => {
      const displayType =
        action.type === 'CreatePathway'
          ? this.translateService.instant('dgGlobalAdd_CreateAPathway')
          : this.contentUtils.getDisplayType(action.type);
      return { ...action, displayType, id: `dgat-globalAdd-${action.type}` };
    })
  );
}
